export default "__VITE_ASSET__DDmfJ94$__"